import { QueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'
const useQueryClient = () => {
	const queryClient = useMemo(() => {
		const client = new QueryClient({
			defaultOptions: {
				queries: {
					// Tiempo de cache por defecto (15 minutos)
					staleTime: 15 * 60 * 1000,
					// Tiempo que los datos permanecen en cache sin usar (60 minutos)
					cacheTime: 60 * 60 * 1000,
					// Reintentar automáticamente en caso de error
					retry: 2,
					// Refetch cuando la ventana obtiene el foco
					refetchOnWindowFocus: false,
					// Refetch cuando se reconecta a internet
					refetchOnReconnect: true
				},
				mutations: {
					// Reintentar mutaciones en caso de error
					retry: 1
				}
			}
		})

		// Configurar persistencia del cache usando localStorage directamente
		if (typeof window !== 'undefined') {
			const cacheKey = 'salud-continua-cache'

			// Restaurar cache al inicializar
			try {
				const cached = localStorage.getItem(cacheKey)
				if (cached) {
					const parsed = JSON.parse(cached)
					// Restaurar cada query individualmente
					Object.entries(parsed).forEach(([, queryData]) => {
						client.setQueryData(queryData.queryKey, queryData.data)
					})
				}
			} catch (error) {
				console.warn('Error al restaurar cache:', error)
			}

			// Guardar cache cuando cambie (con debounce)
			let saveTimeout
			client.getQueryCache().subscribe(() => {
				clearTimeout(saveTimeout)
				saveTimeout = setTimeout(() => {
					try {
						const queries = client.getQueryCache().getAll()
						const successfulQueries = queries
							.filter(query => query.state.status === 'success')
							.reduce((acc, query) => {
								acc[query.queryHash] = {
									data: query.state.data,
									queryKey: query.queryKey,
									state: query.state
								}
								return acc
							}, {})

						localStorage.setItem(cacheKey, JSON.stringify(successfulQueries))
					} catch (error) {
						console.warn('Error al guardar cache:', error)
					}
				}, 1000) // Guardar después de 1 segundo de inactividad
			})
		}

		return client
	}, [])

	return queryClient
}

export default useQueryClient
